import React from "react";
import { Carousel, Button } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";

import FirstSlide from "../../assets/img/imagen_web_1.jpeg";
import SecondSlide from "../../assets/img/imagen web alta 2.jpg";
import ThirdSlide from "../../assets/img/imagen web alta 3.jpg";
// import FourthSlide from "../../assets/img/centros-medicos-new.jpg";
import FourthSlide from "../../assets/img/slideshow_home_3.jpg";

import "../../assets/styles/SlideShow.css"; // Importa tu archivo de estilos

const SlideShow = () => {
  return (
    <Carousel className="slideshow">
      {/* Slide 1 */}
      <Carousel.Item>
        <LazyLoadImage
          className="d-block w-100"
          src={FirstSlide}
          effect="blur"
          alt="First slide"
          loading="lazy"
          style={{ height: "100%" }}
        />
        <Carousel.Caption className="custom-caption">
          <div className="caption-content">
            {/* <h3>Cuidar es escuchar, comprender y acompañar.</h3> */}
            {/* <p>Esta es una breve descripción para la primera imagen.</p> */}
            {/* <Button className="btn-custom" href="https://altasalud.com.ar/nuestros-planes" >
              Conocé
            </Button> */}
          </div>
        </Carousel.Caption>
      </Carousel.Item>

      {/* Slide 2 */}
      <Carousel.Item>
        <LazyLoadImage
          className="d-block w-100"
          src={SecondSlide}
          effect="blur"
          alt="Second slide"
          loading="lazy"
          style={{ height: "100%" }}
        />
        <Carousel.Caption className="custom-caption">
          <div className="caption-content">
            {/* <h3>La salud nos conecta con lo que más valoramos.</h3> */}
            {/* <Button className="btn-custom" href="https://web.whatsapp.com/send?phone=5491161653681&app_absent=1" target="_blank" rel="noopener noreferrer">
              Más info
            </Button> */}
          </div>
        </Carousel.Caption>
      </Carousel.Item>

      {/* Slide 3 */}
      <Carousel.Item>
        <LazyLoadImage
          className="d-block w-100"
          src={ThirdSlide}
          effect="blur"
          alt="Third slide"
          loading="lazy"
          style={{ height: "100%" }}
        />
        <Carousel.Caption className="custom-caption">
          <div className="caption-content">
            {/* <h3>Cerca de las personas, cerca de lo que importa.</h3> */}
            {/* <Button className="btn-custom" href="https://web.whatsapp.com/send?phone=5491161653681&app_absent=1" target="_blank" rel="noopener noreferrer">
              Afiliate
            </Button> */}
          </div>
        </Carousel.Caption>
      </Carousel.Item>

      {/* Slide 4 */}
      <Carousel.Item>
        <LazyLoadImage
          className="d-block w-100"
          src={FourthSlide}
          effect="blur"
          alt="Fourth slide"
          loading="lazy"
          style={{ height: "100%" }}
        />
        <Carousel.Caption className="custom-caption">
          <div className="caption-content">
            {/* <h3>Crecemos para brindarte más espacios de atención.</h3> */}
            {/* <Button className="btn-custom" href="https://web.whatsapp.com/send?phone=5491161653681&app_absent=1" target="_blank" rel="noopener noreferrer">
              Conocé
            </Button> */}
          </div>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
};

export default SlideShow;